export function parseMyOrdersPage(search: URLSearchParams): number {
  const values = search.getAll('page');
  if (values.length !== 1 || !/^[1-9][0-9]*$/.test(values[0] ?? '')) return 1;
  const page = Number(values[0]);
  return Number.isSafeInteger(page) ? page : 1;
}

export function safeHttpsUrl(value: string | null | undefined): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : null;
  } catch {
    return null;
  }
}
/** 서버가 답한 주문 오류 코드 — tRPC 오류 본문 data.orderErrorCode(api-contracts toClientErrorShape). 없으면 null. */
export function orderErrorCodeOf(error: unknown): string | null {
  if (typeof error !== 'object' || error === null || !('data' in error)) return null;
  const data = error.data;
  return typeof data === 'object' &&
    data !== null &&
    'orderErrorCode' in data &&
    typeof data.orderErrorCode === 'string'
    ? data.orderErrorCode
    : null;
}
export function isOrderConflict(error: unknown): boolean {
  return orderErrorCodeOf(error) === 'ORDER_STATE_CONFLICT';
}
/** 주문하기·고객 배송지 변경이 지역 구분이 바뀌는 주소를 거절할 때(SUPER-86 spec D10·D11) — 배송비가 달라지므로 견적 수정 안내. */
export const SHIPPING_REGION_CHANGED_MESSAGE =
  '배송비가 달라지는 지역이에요. 견적 수정을 요청해 주세요.';

export function orderMutationMessage(error: unknown): string {
  if (orderErrorCodeOf(error) === 'SHIPPING_REGION_CHANGED') return SHIPPING_REGION_CHANGED_MESSAGE;
  return isOrderConflict(error)
    ? '주문 상태가 변경되었습니다. 최신 주문을 확인해 주세요.'
    : '요청을 처리하지 못했습니다. 입력을 확인하고 다시 시도해 주세요.';
}

/**
 * 주문하기(orders.place)만 내는 거절 사유 — 고객이 입력을 고쳐도 풀리지 않으므로 "입력을 확인" 대신 사유를 알린다.
 * 서버 코드는 api orders place-order.use-case 의 OrderDomainError 코드다.
 */
const ORDER_PLACEMENT_MESSAGES: Readonly<Record<string, string>> = {
  PRODUCT_UNAVAILABLE: '지금 공급할 수 없는 상품이라 주문할 수 없습니다. 운영자에게 문의해 주세요.',
  ACTIVE_ORDER_EXISTS: '이미 주문한 견적입니다. 내 주문에서 확인해 주세요.',
  QUOTE_EXPIRED: '견적 유효기간이 지나 주문할 수 없습니다.',
  QUOTE_STATE_CONFLICT: '지금은 주문할 수 없는 견적입니다. 내 견적에서 상태를 확인해 주세요.',
  QUOTE_VERSION_OUTDATED: '견적이 다시 발행되었습니다. 최신 견적서를 확인하고 다시 동의해 주세요.',
  INVALID_DESTINATIONS: '배송지가 견적과 맞지 않아요. 주문하기 화면을 다시 열어 주세요.',
  SHIPPING_REGION_CHANGED: SHIPPING_REGION_CHANGED_MESSAGE,
};

/** 주문하기 제출 실패 문구 — 주문하기 전용 사유가 아니면 공용 주문 문구(orderMutationMessage)를 쓴다. */
export function orderPlacementMessage(error: unknown): string {
  const code = orderErrorCodeOf(error);
  return (
    (code !== null ? ORDER_PLACEMENT_MESSAGES[code] : undefined) ?? orderMutationMessage(error)
  );
}
